import styled from 'styled-components';

export const NewMenuContainer = styled.div`
	display: flex !important;
	align-items: center;
	justify-content: space-between;
`;
